import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import {
    MuiPickersUtilsProvider,
    DatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';



const useStyles = makeStyles((theme) => ({
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: "4%",
        marginBottom: "2%",
    },
    main: {
        paddingTop: '10%', backgroundColor: "rgb(246, 249, 252)", minHeight: "100vh",
        [theme.breakpoints.down("sm")]: {
            paddingTop: '32%',
        },
    }
}));


export default function PassengersDetail(props) {
    const classes = useStyles();
    const { adult, index } = props;
    const [title, setTitle] = useState(adult.title)
    const [name, setName] = useState(adult.name)
    const [surname, setSurname] = useState(adult.surname)
    const [birthday, setBirthday] = useState(adult.birthday)

    useEffect(() => {
        if (props.onChange) {
            props.onChange(index, {
                title,
                name,
                surname,
                birthday
            })
        }
    }, [title, name, surname, birthday])



    return (<Paper className={classes.control} elevation={0}>
        <Grid container spacing={4}>
            <Grid item xs="11" sm="11" style={{ textAlign: 'left' }}>
                <Typography style={{
                    color: 'black',
                    background: '#E2E2E8',
                    padding: '6px',
                    fontSize: '12px',
                    fontWeight: '400',
                    borderRadius: '4px',
                    marginRight: "15px"
                }} component="span">{`ADULT ${parseInt(props.index) + 1}`}</Typography>
            </Grid>
            {index > 0 &&
                <Grid item xs="1" sm="1" style={{ textAlign: 'right' }} onClick={() => {
                    props.onRemove(index)
                }}>
                    <div style={{
                        width: '53px',
                        height: '22px',
                        background: 'rgb(1, 160, 90)',
                        border: '1px solid rgb(1, 160, 90)',
                        color: '#fff',
                        borderRadius: '30px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        padding: '0 5px',
                        userSelect: 'none',
                        '&:hover': {
                            boxShadow: '1px 1px 2px #000000'
                        },
                        fontSize: '10px',
                        marginTop: '10px',
                        marginLeft: '10px'
                    }}>
                        <div>Remove</div>
                    </div>
                </Grid>
            }
            <Grid item xs="12" sm="12" style={{ textAlign: 'left' }}>
                <Typography style={{
                    fontSize: '22px',
                }}>{'Personal details'}</Typography>
            </Grid>
            <Grid item xs="12" sm="3">
                <FormControl fullWidth>
                    <InputLabel id="demo-customized-sort-label">Title</InputLabel>
                    <Select
                        fullWidth
                        labelId="demo-customized-stops-label"
                        id="demo-customized-stops"
                        style={{ height: '100%' }}
                        value={title}
                        onChange={(e) => {
                            setTitle(e.target.value)
                        }}
                    >
                        <MenuItem value={'mr'}>Mr.</MenuItem>
                        <MenuItem value={'ms'}>Ms.</MenuItem>
                        <MenuItem value={'mrs'}>Mrs.</MenuItem>
                        <MenuItem value={'miss'}>Miss.</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs="12" sm="3">
                <TextField
                    label="First Name"
                    error={name !== null && name.length === 0}
                    fullWidth
                    value={name}
                    id="outlined-error-helper-text"
                    helperText={name !== null && name.length === 0 ? "Name is required" : ''}
                    variant="outlined"
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                />
            </Grid>
            <Grid item xs="12" sm="3">
                <TextField
                    label="Surname"
                    error={surname !== null && surname.length === 0}
                    fullWidth
                    value={surname}
                    id="outlined-error-helper-text"
                    helperText={surname !== null && surname.length === 0 ? "Surname is required" : ''}
                    variant="outlined"
                    onChange={(e) => {
                        setSurname(e.target.value)
                    }}

                />
            </Grid>
            <Grid item xs="12" sm="3">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        label="Date of Birth"
                        style={{ width: '100%', marginTop: '0px' }}
                        disableToolbar
                        error={birthday !== null && birthday.length === 0}
                        inputVariant="outlined"
                        placeholder="DD-MM-YYYY"
                        value={birthday}
                        onChange={(e) => {
                            setBirthday(e)
                        }}
                        maxDate={moment().subtract(18, 'years')}
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
        </Grid>
    </Paper>

    )

}